import React from 'react';
import PropTypes from 'prop-types';

import BaseModal from 'components/UI/BaseModal';
import Box from '@mui/material/Box';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import ErrorIcon from '@mui/icons-material/Error';
import Typography from '@mui/material/Typography';

const Icon = ({ color, type }) => {
  switch (type) {
    case 'success':
      return <LibraryAddCheckIcon color={color} />;
    case 'error':
      return <ErrorIcon color={color} />;
    default:
      return null;
  }
};

Icon.propTypes = {
  color: PropTypes.oneOf(['primary', 'error']),
  type: PropTypes.oneOf(['success', 'error']).isRequired,
};

const MessagesModal = ({ open, onClose, type, title, message }) => {
  const color = type === 'success' ? 'primary' : 'error';

  return (
    <BaseModal open={open} handleClick={onClose}>
      <Box sx={{ pt: 4, pb: 10 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Icon color={color} type={type} />
        </Box>
        <Box>
          <Typography color={color} align="center" variant="h6">
            {title}
          </Typography>
        </Box>
        <Box sx={{ maxWidth: 400, mt: 2, mx: 'auto' }}>
          <Typography variant="body1" align="center">
            {message}
          </Typography>
        </Box>
      </Box>
    </BaseModal>
  );
};

MessagesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['success', 'error']).isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default MessagesModal;
